import { useMemo } from "react";
import { ReactComponent as Cognitive1Svg } from "../../vendor/icons/Cognitive1.svg";
import { ReactComponent as Cognitive2Svg } from "../../vendor/icons/Cognitive2.svg";
import { ReactComponent as Cognitive3Svg } from "../../vendor/icons/Cognitive3.svg";

import { ReactComponent as FoodAllergy1Svg } from "../../vendor/icons/Food Allergies 1.svg";
import { ReactComponent as FoodAllergy2Svg } from "../../vendor/icons/Food Allergies 2.svg";
import { ReactComponent as FoodAllergy3Svg } from "../../vendor/icons/Food Allergies 3.svg";

import { ReactComponent as Hearing1Svg } from "../../vendor/icons/Hearing 1.svg";
import { ReactComponent as Hearing2Svg } from "../../vendor/icons/Hearing 2.svg";
import { ReactComponent as Hearing3Svg } from "../../vendor/icons/Hearing 3.svg";

import { ReactComponent as Mobility1Svg } from "../../vendor/icons/Mobility 1.svg";
import { ReactComponent as Mobility2Svg } from "../../vendor/icons/Mobility 2.svg";
import { ReactComponent as Mobility3Svg } from "../../vendor/icons/Mobility 3.svg";


import { ReactComponent as RoomAllergies1Svg } from "../../vendor/icons/Room Allergies 1.svg";
import { ReactComponent as RoomAllergies2Svg } from "../../vendor/icons/Room Allergies 2.svg";
import { ReactComponent as RoomAllergies3Svg } from "../../vendor/icons/Room Allergies 3.svg";

import { ReactComponent as Visual1Svg } from "../../vendor/icons/Visual 1.svg";
import { ReactComponent as Visual2Svg } from "../../vendor/icons/Visual 2.svg";
import { ReactComponent as Visual3Svg } from "../../vendor/icons/Visual 3.svg";

import { useTranslation } from "react-i18next";

export const GetIconsBasedOnClassification = (props: {
    classification: {
        allergy_food_class: number;
        allergy_room_class: number;
        mobility_class: number;
        hearing_class: number;
        cognitive_class: number;
        visual_class: number;
    }
}) => {
    const { classification } = props;
    const { t } = useTranslation();
    type K = (keyof (typeof classification));
    const keys: K[] = useMemo(() => Object.keys(classification).filter(key => (classification as any)[key] !== 0) as any, [classification]);

    const GetIcon = (key: K) => {
        const Icon = MappedIcons[key][classification[key]]
        return <Icon width="100%" height="100%" style={{
            width: "25px",
            heigth: "25px"
        }} />;
    }

    const MappedIcons = {
        allergy_food_class: {
            1: FoodAllergy1Svg, 2: FoodAllergy2Svg, 3: FoodAllergy3Svg,
            name: t("propertyListIconName_allergy_food_class")
        },
        allergy_room_class: {
            1: RoomAllergies1Svg, 2: RoomAllergies2Svg, 3: RoomAllergies3Svg,
            name: t("propertyListIconName_allergy_room_class")
        },
        mobility_class: {
            1: Mobility1Svg, 2: Mobility2Svg, 3: Mobility3Svg,
            name: t("propertyListIconName_mobility_class")
        },
        hearing_class: {
            1: Hearing1Svg, 2: Hearing2Svg, 3: Hearing3Svg,
            name: t("propertyListIconName_hearing_class")
        },
        cognitive_class: {
            1: Cognitive1Svg, 2: Cognitive2Svg, 3: Cognitive3Svg,
            name: t("propertyListIconName_cognitive_class")
        },
        visual_class: {
            1: Visual1Svg, 2: Visual2Svg, 3: Visual3Svg,
            name: t("propertyListIconName_visual_class")
        },
    } as any;

    return (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", width: "100%" }}>
            {keys.map((key, i) => (
                <div key={i} title={`${MappedIcons[key].name} ${classification[key]}`} style={{
                    marginRight: "5px"
                }}>
                    {GetIcon(key)}
                </div>
            ))}
            {keys.length === 0 && <div style={{
                display: "flex",
                height: "25px",
                alignItems: "center",
                background: "rgba(238, 238, 238, 0.05)",
                borderRadius: "65px",
                padding: "0px 10px",
            }}>
                {t("propertyListPage_NotClassified")}
            </div>}
        </div>
    )
}